import React from 'react';

const LoadingDots = () => {
  return (
    <div className="flex items-center justify-start p-4">
      <div className="inline-flex space-x-1.5 items-center">
        <div
          className="w-2.5 h-2.5 bg-gray-600 rounded-full animate-[bounce_0.9s_ease-in-out_infinite]"
          style={{
            animation: 'bounce 0.9s ease-in-out infinite',
          }}
        />
        <div
          className="w-2.5 h-2.5 bg-gray-600 rounded-full animate-[bounce_0.9s_ease-in-out_infinite]"
          style={{
            animation: 'bounce 0.9s ease-in-out infinite',
            animationDelay: '0.15s',
          }}
        />
        <div
          className="w-2.5 h-2.5 bg-gray-600 rounded-full animate-[bounce_0.9s_ease-in-out_infinite]"
          style={{
            animation: 'bounce 0.9s ease-in-out infinite',
            animationDelay: '0.3s',
          }}
        />
      </div>
    </div>
  );
};

export default LoadingDots;
